import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

import { getUserDataWithResources } from 'store/userProfile/services/getUserDataWithResources.service';

export const loadUserDataWithResources = createAsyncThunk(
  'users/loadUserDataWithResources',
  async (params, { getState }) => {
    const userActiveEmployerInfo = selectUserActiveEmployerInfo(getState());

    const { userId } = params;
    const userData = await getUserDataWithResources(
      userId,
      userActiveEmployerInfo
    );

    return userData;
  }
);
